import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';
import OrderDashboardNavLink from '../../Layout/OrderDashboardNavLink';
import SeriesNavElement from '../SeriesNavElement/Root/index.jsx';

const SeriesDetailNav = ({
  selectedModelId,
  selectedSeriesId,
  seriesListIds,
  mini,
}) => (
  <div className={mini ? styles.seriesMiniDetailNav : styles.seriesDetailNav}>
    <div className={styles.link}>
      <OrderDashboardNavLink />
    </div>
    <div className={styles.navSection}>
      {seriesListIds.map(seriesId => (
        <SeriesNavElement
          key={seriesId}
          seriesId={seriesId}
          selectedModelId={selectedModelId}
          selectedSeriesId={selectedSeriesId}
        />
      ))}
    </div>
  </div>
);

SeriesDetailNav.propTypes = {
  selectedModelId: PropTypes.string.isRequired,
  selectedSeriesId: PropTypes.string.isRequired,
  seriesListIds: PropTypes.array.isRequired,
  mini: PropTypes.bool.isRequired,
};

export default enhance(SeriesDetailNav);
